import { useContext } from "react";
import AuthContext from "./contexts/AuthProvider";

export default function LogOut() {
  const { logoutUser } = useContext(AuthContext);
  logoutUser();
}
